import { render, staticRenderFns } from "./attendance-add-or-update.vue?vue&type=template&id=3b13e86e&scoped=true"
import script from "./attendance-add-or-update.vue?vue&type=script&lang=js"
export * from "./attendance-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./attendance-add-or-update.vue?vue&type=style&index=0&id=3b13e86e&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b13e86e",
  null
  
)

export default component.exports